__turbopack_context__.v({
  "bodyContent": "BottomNavLayout-module-scss-module__2HwB7q__bodyContent",
  "bodyContentNoTop": "BottomNavLayout-module-scss-module__2HwB7q__bodyContentNoTop",
  "bottomNavbarWrapper": "BottomNavLayout-module-scss-module__2HwB7q__bottomNavbarWrapper",
});
